module.exports = __webpack_public_path__ + "img/Card_safety_sites.6e7b9cb6.png";